"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Parser = void 0;
var chroma_js_1 = __importDefault(require("chroma-js"));
var Person_1 = require("./models/Person");
var Era_1 = require("./models/Era");
var Event_1 = require("./models/Event");
var Facet_1 = require("./models/Facet");
var luxon_1 = require("luxon");
var Parser = /** @class */ (function () {
    function Parser() {
    }
    Parser.prototype.parseData = function (data) {
        var _this = this;
        var facets = Object.keys(data).map(function (facetName) {
            return new Facet_1.Facet(facetName, (data[facetName].eras || []).map(function (it) { return _this.parseEra(it); }), (data[facetName].people || []).map(function (it) { return _this.parsePerson(it); }), (data[facetName].events || []).map(function (it) { return _this.parseEvent(it); }));
        }).sort(function (one, two) { return one.orderByStart(two); });
        this.setColors(facets);
        return facets;
    };
    Parser.prototype.setColors = function (facets) {
        var colorScale = chroma_js_1.default.scale('Viridis').domain([0, facets.length - 1]);
        facets.forEach(function (it, index) {
            it.basecolor = colorScale(index);
        });
    };
    Parser.prototype.parseEra = function (_a) {
        var name = _a.name, start = _a.start, end = _a.end, _b = _a.url, url = _b === void 0 ? '' : _b;
        return new Era_1.Era(name, this.parseDate(start), this.parseDate(end), url);
    };
    Parser.prototype.parsePerson = function (_a) {
        var _this = this;
        var name = _a.name, birth = _a.birth, death = _a.death, url = _a.url, _b = _a.events, events = _b === void 0 ? [] : _b, _c = _a.short_name, short_name = _c === void 0 ? '' : _c;
        return new Person_1.Person(name, this.parseDate(birth), this.parseDate(death), url, events.map(function (it) { return _this.parseEvent(it); }), short_name === '' ? name : short_name);
    };
    Parser.prototype.parseEvent = function (_a) {
        var name = _a.name, date = _a.date, url = _a.url;
        return new Event_1.Event(name, this.parseDate(date), url);
    };
    Parser.prototype.parseDate = function (string) {
        if (string === 'now') {
            return luxon_1.DateTime.local();
        }
        else if (string.startsWith('-')) {
            return luxon_1.DateTime.fromISO("-00".concat(string.substr(1)));
        }
        return luxon_1.DateTime.fromISO(string);
    };
    return Parser;
}());
exports.Parser = Parser;
